import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconChevronUp = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 15 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0)",
		children: /* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M12.2533 8.38664C11.9012 8.02414 8.1826 4.48245 8.1826 4.48245C7.99355 4.2882 7.74553 4.19107 7.49924 4.19107C7.25122 4.19107 7.0032 4.2882 6.81588 4.48245C6.81588 4.48245 3.09727 8.02414 2.74345 8.38664C2.38963 8.74913 2.36535 9.40128 2.74345 9.78805C3.11982 10.1748 3.64709 10.2043 4.11018 9.78805L7.49924 6.53774L10.8883 9.78805C11.3514 10.2043 11.8769 10.1748 12.2533 9.78805C12.6314 9.40128 12.6071 8.74913 12.2533 8.38664Z",
			fill: "currentColor"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 11,
			height: 6.28571,
			fill: "white",
			transform: "matrix(1 0 0 -1 2 10.2857)"
		})
	}) })]
});
export default SvgIconChevronUp;
